import React from 'react'
import WebFeaturebox1 from './Web-feature-box1'
function Webfeature() {
    return (
        <>
            <WebFeaturebox1 />
        </>
    )
}

export default Webfeature